import { InputParsedNumber } from '@shared/components'
import { Col, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import { usePropertyInsuranceValues } from './PropertyInsuranceContext'

type Props = {
  fieldKey: number
}

export const ItemCategoryFFields = ({ fieldKey }: Props) => {
  const { t } = useTranslation()
  const { isEditable } = usePropertyInsuranceValues()

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} md={12}>
        <Form.Item name={[fieldKey, 'f', 'quantity']} label={t('quantity')}>
          <InputParsedNumber
            min={0}
            placeholder={t('quantity')}
            className="w-full"
            disabled={isEditable}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
